import { render, staticRenderFns } from "./BaseRoundedButton.vue?vue&type=template&id=3ea778d8&scoped=true&"
import script from "./BaseRoundedButton.vue?vue&type=script&lang=js&"
export * from "./BaseRoundedButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseRoundedButton.vue?vue&type=style&index=0&id=3ea778d8&lang=scss&scoped=true&"
import style1 from "./BaseRoundedButton.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea778d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VHover,VIcon,VTooltip})
